// extracted by mini-css-extract-plugin
module.exports = {"list":"list__On4Rh","item":"item__1VYwx","more":"more__3U4es"};